import prepareOptions from '../../prepareOptions';

import {
  BLACK,
  GRAY,
  WHITE,
  SILVER,
  BROWN,
  RED,
  BLUE,
  GREEN,
  BEIGE,
  YELLOW,
  ORANGE,
  PURPLE,
  GOLD,
} from './values';

export default prepareOptions([
  {
    value: BLACK,
    outerColor: 'black',
    label: __('carDetails.outsideColor.black'),
  },
  {
    value: GRAY,
    outerColor: 'gray',
    label: __('carDetails.outsideColor.gray'),
  },
  {
    value: WHITE,
    outerColor: 'white',
    label: __('carDetails.outsideColor.white'),
  },
  {
    value: ORANGE,
    outerColor: 'orange',
    label: __('carDetails.outsideColor.orange'),
  },
  {
    value: BLUE,
    outerColor: 'blue',
    label: __('carDetails.outsideColor.blue'),
  },
  {
    value: BROWN,
    outerColor: 'brown',
    label: __('carDetails.outsideColor.brown'),
  },
  {
    value: RED,
    outerColor: 'red',
    label: __('carDetails.outsideColor.red'),
  },
  {
    value: SILVER,
    outerColor: 'silver',
    label: __('carDetails.outsideColor.silver'),
  },
  {
    value: YELLOW,
    outerColor: 'yellow',
    label: __('carDetails.outsideColor.yellow'),
  },
  {
    value: GREEN,
    outerColor: 'green',
    label: __('carDetails.outsideColor.green'),
  },
  {
    value: BEIGE,
    outerColor: 'beige',
    label: __('carDetails.outsideColor.beige'),
  },
  {
    value: GOLD,
    outerColor: 'gold',
    label: __('carDetails.outsideColor.gold'),
  },
  {
    value: PURPLE,
    outerColor: 'purple',
    label: __('carDetails.outsideColor.purple'),
  },
]);
